import { render, staticRenderFns } from "./TotalExpenses.vue?vue&type=template&id=476d82de&"
import script from "./TotalExpenses.vue?vue&type=script&lang=js&"
export * from "./TotalExpenses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports